import { ActionTypeList } from '../../constants'

const initialState = {
    currentUserId: ''
};

const currentUserIdPayload = (state = initialState, action) => {
    //console.log(`currentUserIdPayload state ${JSON.stringify(state)} action ${JSON.stringify(action)}`);

    switch (action.type) {
        case ActionTypeList.USER_SETTING_CURRENT_USER_ID_UPDATED:
            return action.payload;
        default:
            return state;
    }
}

export default currentUserIdPayload;